export class FileUploadConfig {
    static readonly AllowedFileTypes = ['image', 'doc', 'pdf', 'xls', 'application', 'compress', 'video'];
    static readonly MaxFileSizeInBytes = 10 * 1024 * 1024; // 10 MB
}
